import { forwardRef, HTMLAttributes, PropsWithChildren, useContext } from 'react';

import FieldsetContext from '../context';

import s from './FieldsetLabel.module.scss';

export type FieldsetLabelProps = PropsWithChildren<HTMLAttributes<HTMLSpanElement>>;

const FieldsetLabel = forwardRef<HTMLSpanElement, FieldsetLabelProps>((props, ref) => {
  const FieldsetLabelContext = useContext(FieldsetContext);

  if (FieldsetLabelContext?.isRequired)
    return (
      <div className={s.wrapper}>
        <span className={s.text} {...props} ref={ref} />
        <span className={s.required}>(필수)</span>
      </div>
    );

  if (FieldsetLabelContext?.isOptional)
    return (
      <div className={s.wrapper}>
        <span className={s.text} {...props} ref={ref} />
        <span className={s.optional}>(선택)</span>
      </div>
    );

  return (
    <div className={s.wrapper}>
      <span className={s.text} {...props} ref={ref} />
    </div>
  );
});

export default FieldsetLabel;
